import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import Joyride, { STATUS } from 'react-joyride';
import { LEARN_TIP } from '../utils/testing/TestIDs';
import LearnTip from './LearnTip';
import { LearnTipModal } from './LearnTipModal';
import './styles.css';
import { LEARN_TIP_HIDDEN } from './utils';

var LearnTips = function LearnTips(_ref) {
  var steps = _ref.steps,
      handleComplete = _ref.handleComplete,
      run = _ref.run,
      className = _ref.className,
      _ref$disableScrolling = _ref.disableScrolling,
      disableScrolling = _ref$disableScrolling === void 0 ? false : _ref$disableScrolling,
      _ref$disableFlip = _ref.disableFlip,
      disableFlip = _ref$disableFlip === void 0 ? false : _ref$disableFlip,
      _ref$disableCloseOnEs = _ref.disableCloseOnEsc,
      disableCloseOnEsc = _ref$disableCloseOnEs === void 0 ? true : _ref$disableCloseOnEs;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  var updatedSteps = steps.map(function (step, index) {
    return {
      onNextClickAnalyticsCallback: step.onNextClickAnalyticsCallback,
      onCloseClickAnalyticsCallback: step.onCloseClickAnalyticsCallback,
      title: step.title,
      content: step.body,
      placement: step.placement,
      textAlign: 'left',
      target: step.target,
      badgeText: step.badgeText,
      badgeColor: step.badgeColor,
      badgeIcon: step.badgeIcon,
      dataTestId: step.dataTestId || LEARN_TIP,
      disableBeacon: index === 0,
      isFixed: true,
      width: step.width,
      offset: step.offset || 15,
      backgroundImageUrl: step.backgroundImageUrl,
      tipAdjustment: step.tipAdjustment,
      pointerAdjustment: step.pointerAdjustment,
      showButtons: step.showButtons === undefined ? true : step.showButtons,
      spotlightPadding: step.spotlightPadding || 0,
      buttonMessage: step.buttonMessage,
      buttonPosition: step.buttonPosition,
      bodyCTAText: step.bodyCTAText,
      skipButtonColor: step.skipButtonColor,
      skipButtonIcon: step.skipButtonIcon,
      handleBodyCTA: step.handleBodyCTA,
      handleButton: step.handleButton,
      styles: {
        spotlight: {
          borderRadius: step.borderRadius || '0px'
        },
        overlay: {
          zIndex: step.zIndex || 2000000
        }
      }
    };
  });

  var handleJoyrideCallback = function handleJoyrideCallback(props) {
    if (props.status === STATUS.FINISHED || props.status === STATUS.SKIPPED) {
      document.body.style.overflow = 'unset';
    }

    setActiveStep(props.index);
    handleComplete === null || handleComplete === void 0 ? void 0 : handleComplete(props);
  };

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  useEffect(function () {
    setTimeout(function () {
      setLoading(false);
    }, 1000);
  }, []);
  useEffect(function () {
    if (run) {
      document.body.style.overflow = 'hidden';
    }
  }, [run]); // Hide Learn Tip for integration test with cy.setLearnTipHidden()

  if (localStorage.getItem(LEARN_TIP_HIDDEN) === 'true') {
    return null;
  }

  return /*#__PURE__*/React.createElement(Joyride, {
    run: !loading ? run : false,
    steps: updatedSteps,
    beaconComponent: undefined,
    callback: handleJoyrideCallback,
    continuous: true,
    disableOverlayClose: true,
    disableScrolling: disableScrolling,
    disableCloseOnEsc: disableCloseOnEsc,
    scrollOffset: 800,
    tooltipComponent: function tooltipComponent(props) {
      return /*#__PURE__*/React.createElement(LearnTip, _extends({
        className: className
      }, props, {
        activeStep: activeStep
      }));
    },
    floaterProps: {
      hideArrow: true,
      options: {
        arrow: {
          enabled: true,
          element: '.learntip-arrow'
        }
      },
      disableFlip: disableFlip
    },
    styles: {
      options: {
        zIndex: 2000000,
        spotlightShadow: 'none'
      },
      overlay: {
        backgroundColor: 'rgba(25, 25, 25, 0.5)'
      }
    }
  });
};

export { LearnTips, LearnTipModal };